<h1 mat-dialog-title>Selecionar Tipo de Processo</h1>

<div mat-dialog-content>
  <!-- Exibe o spinner enquanto os dados estão sendo carregados -->
  <div *ngIf="isLoading" class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>

  <form [formGroup]="processTypeForm" *ngIf="!isLoading">
    <!-- Campo de seleção para o tipo de processo -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Tipo de Processo</mat-label>
      <mat-select formControlName="processType" required>
        <mat-option *ngFor="let type of processTypes" [value]="type.id">
          {{ type.nome }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="hasError('processType', 'required')">
        Selecione um tipo de processo
      </mat-error>
    </mat-form-field>

    <!-- Campo para o prazo em dias -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Prazo (em dias)</mat-label>
      <input
        matInput
        type="number"
        formControlName="dueDays"
        min="1"
        placeholder="Informe o prazo"
        required
      />
      <mat-error *ngIf="hasError('dueDays', 'required')">
        Informe o prazo
      </mat-error>
      <mat-error *ngIf="hasError('dueDays', 'min')">
        O prazo deve ser maior que 0
      </mat-error>
    </mat-form-field>
  </form>
</div>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>

  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="processTypeForm.invalid"
  >
    Selecionar
  </button>
</mat-dialog-actions>
